import librefranklin400ttf from './libre-franklin-400.ttf';
import librefranklin400woff from './libre-franklin-400.woff';
import librefranklin400woff2 from './libre-franklin-400.woff2';

import librefranklin500ttf from './libre-franklin-500.ttf';
import librefranklin500woff from './libre-franklin-500.woff';
import librefranklin500woff2 from './libre-franklin-500.woff2';

import librefranklin700ttf from './libre-franklin-700.ttf';
import librefranklin700woff from './libre-franklin-700.woff';
import librefranklin700woff2 from './libre-franklin-700.woff2';

const libreFranklinSrc = {
  400: {
    woff: librefranklin400woff,
    woff2: librefranklin400woff2,
    ttf: librefranklin400ttf,
    otf: undefined,
  },
  500: {
    woff: librefranklin500woff,
    woff2: librefranklin500woff2,
    ttf: librefranklin500ttf,
    otf: undefined,
  },
  700: {
    woff: librefranklin700woff,
    woff2: librefranklin700woff2,
    ttf: librefranklin700ttf,
    otf: undefined,
  },
};
export { libreFranklinSrc };
